import React from 'react'

import { ConfigProvider, theme } from 'antd'

import './App.css'

import SiteWrapper from './components/SiteWrapper'
import Site from './site/Site'

// 🔴 THERE IS NO ANALYTICS CALL HERE ANY MORE — and that is deliberate.
//
// This file used to call `ReactGA.initialize(REACT_APP_MEASUREMENT_ID)` as it rendered,
// with a `ReactGA.event(...)` on every guess in Site.js. That is a SECOND way into Google
// that the cookie gate cannot see: the gate's whole promise is that a visit that refuses
// makes no request to Google at all, and a library that initialises at render time breaks
// that promise whatever the gate does.
//
// The gate is now the only thing on this site that may load Google's script, and it also
// sends the page views, clicks and scroll depth itself. Removing react-ga4 removes the
// duplicate rather than hiding it.
const App = () => {
  return (
    <ConfigProvider
      theme={{
        algorithm: theme.darkAlgorithm,
        token: {
          colorPrimary: '#34d399',
          colorBgBase: '#05130e',
          colorBgContainer: '#11161d',
          colorBgElevated: '#18202a',
          colorBorder: 'rgba(255,255,255,0.08)',
          colorText: '#e6edf3',
          colorTextSecondary: '#8b98a5',
          borderRadius: 12,
          colorSuccess: '#34d399',
          colorWarning: '#fbbf24',
          colorError: '#f87171'
        }
      }}
    >
      {/* min-height rather than height: the page now ends with a three-line footer and,
          on a first visit, the cookie question above it. Fixing the wrapper to exactly one
          viewport tall would clip the footer the moment the content is shorter than the
          window, which is how a footer becomes unreachable. */}
      <div style={{ minHeight: '100vh' }}>
        <SiteWrapper>
          <Site />
        </SiteWrapper>
      </div>
    </ConfigProvider>
  )
}

export default App
